<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory')">Inventario y Actuaciones</a>
      <i class="right angle icon divider"></i>
      <a class="active section">Actuaciones</a>
    </div>
    <h1 class="ui header">
      <i class="icon file alternate outline"></i>
      <div class="content">Actuaciones</div>
    </h1>
    <button class="ui basic button rightButton" v-on:click="goTo('/inventory/action/add')">
      <i class="add icon"></i>Nueva Actuación
    </button>
    <div class="ui stackable">
      <div class="row">
        <h4 class="ui dividing header">Buscar una actuación</h4>
        <div>
          <form class="ui form" @submit.prevent="searchAction">
            <div class="four fields">
              <div class="field">
                <sui-dropdown fluid search multiple selection :options="apmsOptions" v-model="search.apm"
                  placeholder="Máquinas" />
              </div>
              <div class="field">
                <sui-dropdown fluid search multiple selection :options="countryOptions" v-model="search.country"
                  placeholder="Países" />
              </div>
              <div class="field">
                <sui-dropdown fluid search multiple selection :options="columnsOptions" v-model="search.columnas"
                  placeholder="Columnas" />
              </div>
              <div class="field">
                <sui-dropdown fluid search multiple selection :options="stocksOptions" v-model="search.repuestos"
                  placeholder="Repuestos" />
              </div>
            </div>

            <div class="four fields">
              <div class="field">
                <sui-dropdown fluid search multiple selection :options="typesOptions" v-model="search.action_type"
                  placeholder="Tipo actuación" />
              </div>
              <div class="field">
                <sui-dropdown fluid search multiple selection :options="clientsOptions" v-model="search.client"
                  placeholder="Cliente" />
              </div>
              <div class="field">
                <sui-dropdown fluid search multiple selection :options="imputationsOptions" v-model="search.imputation"
                  placeholder="Imputación" />
              </div>
              <div class="field">
                <sui-dropdown fluid search multiple selection :options="actionProvidersOptions"
                  v-model="search.action_providers" placeholder="Proveedor actuación" />
              </div>
            </div>
            <div class="four fields">
              <div class="field">
                <sui-input onfocus="(this.type='date')" onblur="(this.type='text')" icon='calendar'
                  placeholder="Fecha Actuación Inicio" v-model="search.start_date" />
              </div>
              <div class="field">
                <sui-input onfocus="(this.type='date')" onblur="(this.type='text')" icon='calendar'
                  placeholder="Fecha Actuación Fin" v-model="search.end_date" />
              </div>
              <div class="field">
                <sui-dropdown fluid search multiple selection :options="actionStatusOptions"
                  v-model="search.action_status" placeholder="Estado actuación" />
              </div>
            </div>
            <div class="three fields">
              <!-- <div class="field">
                <div class="ui toggle checkbox">
                  <input type="checkbox" name="only_closed" v-model="search.only_closed">
                  <label>Mostrar solo finalizadas</label>
                </div>
              </div> -->
              <div class="field"></div>
              <div class="field">
                <button class="ui button fluid" type="submit">Buscar</button>
              </div>
            </div>

          </form>
        </div>
      </div>
      <div v-if="searching" class="ui active centered inline loader"></div>
      <div v-if="(rows.length != 0)" class="row">
        <div class="column">
          <b></b>
          <h4 class="ui dividing header">Total Actuaciones: {{ totalActions }}</h4>
          <vue-good-table :columns="columns" :rows="rows" :lineNumbers="true" :pagination-options="{
            perPage: 50,
            enabled: true,
            mode: 'pages'
          }" :sort-options="{
            enabled: true,
            initialSortBy: { field: 'action_date', type: 'desc' }
          }" @on-row-click="actionInfo" styleClass="vgt-table striped condensed bordered">
            >
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
import { convertCurrencyFromDDBB } from '@/tools/Utils.js';
export default {
  name: 'actionList',
  data() {
    return {
      totalActions: 0,
      searching: false,
      search: {
        action_type: [],
        apm_name: [],
        country: [],
        client: [],
        repuestos: [],
        columnas: [],
        imputation: [],
        start_date: null,
        end_date: null,
        action_status: false,
        action_providers: false
      },
      columns: [
        {
          label: 'Fecha Actuación',
          field: 'action_date',
          width: '120px',
          type: 'datetime-local',
          dateInputFormat: 'YYYY-MM-DD H:m',
          dateOutputFormat: 'YYYY-MM-DD H:m',
        },
        {
          label: 'País',
          field: 'country',
          filterOptions: {
            placeholder: 'País',
            enabled: true,
            trigger: 'keyup',
          }
        },
        {
          label: 'APM',
          field: 'apm_name',
          filterOptions: {
            placeholder: 'APM',
            enabled: true,
            trigger: 'keyup',
          }
        },
        {
          label: 'Tipo Actuación',
          field: 'type',
          filterOptions: {
            placeholder: 'Tipo Actuación',
            enabled: true,
            trigger: 'keyup',
          }
        },
        {
          label: 'Cliente',
          field: 'client_name',
          filterOptions: {
            placeholder: 'Cliente',
            enabled: true,
            trigger: 'keyup',
          }
        },
        {
          label: 'Imputacion',
          field: 'imputation',
          filterOptions: {
            placeholder: 'Imputacion',
            enabled: true,
            trigger: 'keyup',
          }
        },
        {
          label: 'Proveedor de actuaciones',
          field: 'action_provider',
          filterOptions: {
            placeholder: 'Proveedor de actuaciones',
            enabled: true,
            trigger: 'keyup',
          }
        },
        {
          label: 'Envío Piezas',
          field: 'send_stock',
          filterOptions: {
            placeholder: 'Envío Piezas',
            enabled: true,
            trigger: 'keyup',
            filterFn: (rowValue, filterText) => {
              const filterMap = {
                'si': true,
                'no': false
              }
              const filterValue = filterMap[filterText.toLowerCase()]
              return (filterValue === undefined) ? false : (filterValue === rowValue)
            }
          },
          formatFn: (value) => value ? 'SI' : 'NO'
        },
        {
          label: 'Estado actuación',
          field: 'action_status',
          filterOptions: {
            placeholder: 'Estado actuación',
            enabled: true,
            trigger: 'keyup',
          },
          formatFn: (value) => value.toUpperCase()
        },
        {
          label: 'Precio Proveedor',
          field: 'imputation_cost_provider',
          filterOptions: {
            placeholder: 'Precio Proveedor',
            enabled: true,
            trigger: 'keyup',
          },
          formatFn: (value) => value ? convertCurrencyFromDDBB(value) : value
        },
        {
          label: 'Precio Hapiick',
          field: 'cost_action_hapiick',
          filterOptions: {
            placeholder: 'Precio Hapiick',
            enabled: true,
            trigger: 'keyup',
          },
          formatFn: (value) => value ? convertCurrencyFromDDBB(value) : value
        }
      ],
      rows: [],
      clientsOptions: [],
      apmsOptions: [],
      imputationsOptions: [],
      typesOptions: [],
      stocksOptions: [],
      columnsOptions: [],
      countryOptions: [],
      actionStatusOptions: [],
      actionProvidersOptions: [],
    }
  },
  created() {
    const role = JSON.parse(localStorage.admin).role;

    if (role === 'master' || role === 'admin') {
      this.getDataFilters()
      this.getStocks()
    } else {
      this.$router.replace('/inventory')
    }
  },
  methods: {
    async getDataFilters() {
      await hapiickApi().post('/v2/shipments/filters', {
        admin_id: JSON.parse(localStorage.admin).id,
        HapiickClient: true,
        Apt: true,
        Imputation: true,
        ActionType: true,
        Country: true,
        ActionStatus: true,
        ActionProvider: true,
      })
        .then(request => {
          let { clients, apms, imputations, types, country, actionStatus, providers } = { ...request.data.data }
          this.fillClientsOptions(clients);
          this.fillApmsOptions(apms);
          this.fillImputationsOptions(imputations);
          this.fillTypesOptions(types);
          this.fillCountryOptions(country);
          this.fillStatusOptions(actionStatus);
          this.fillActionProvidersOptions(providers);
        })
        .catch(() => console.log('error getting combo informations'))
    },
    async getStocks() {
      await hapiickApi().post('/v1/stocks', {
        admin_id: JSON.parse(localStorage.admin).id,
      })
        .then(request => {
          let stocks_orig = JSON.parse(JSON.stringify(request.data.stocks));
          if (stocks_orig.length > 0) {
            this.fillStocksOptions(stocks_orig)
          } else {
            this.stocksOptions.push({
              'text': 'No hay repuestos para el modelo de esta máquina',
            })
            this.columnsOptions.push({
              'text': 'No hay repuestos para el modelo de esta máquina',
            })
          }
        })
        .catch((req) => {
          console.log('error getting stocks')
          console.log(req)
        })
    },
    searchAction() {
      this.searching = true
      this.rows = []
      if (this.search.start_date > this.search.end_date) {
        this.$swal({
          type: 'info',
          text: 'La fecha inicio no puede ser superior a la fecha fin'
        })
        return this.rows.push({
          'action_date': 'no encontrado',
        })
      }

      let search = {}
      Object.keys(this.search).forEach((key) => {
        if (this.search[key] && this.search[key].length > 0) {
          search[key] = this.search[key]
        }
      })
      hapiickApi().post('/v1/actions/search', {
        admin_id: JSON.parse(localStorage.admin).id,
        search: search
      })
        .then(request => {
          this.searching = false
          this.updateTable(request.data)
        })
        .catch((err) => {
          this.searching = false
          this.$swal({
            type: 'error',
            title: 'Error',
            text: 'Error al obtener las actuaciones.'
          })

          this.rows.push({
            'action_date': 'no encontrado',
          })
        })
    },
    updateTable(info) {
      const { actions } = { ...info.data }
      this.totalActions = actions.length
      if (this.totalActions === 0) {
        this.rows.push({ 'action_date': 'no encontrado' })
      } else {
        this.rows = actions
      }
    },
    fillClientsOptions(data) {
      this.clientsOptions = data.map((a) => {
        return {
          key: a.HapiickClient.id,
          text: a.HapiickClient.name,
          value: a.HapiickClient.id
        }
      });
    },
    fillApmsOptions(data) {
      this.apmsOptions = data.map((a) => {
        return {
          key: a.Apt.id,
          text: a.LanguagesApts[0].name,
          value: a.Apt.id
        }
      });
    },
    fillImputationsOptions(data) {
      this.imputationsOptions = data.map((a) => {
        return {
          key: a.Imputation.key,
          text: a.Imputation.name,
          value: a.Imputation.id
        }
      })
    },
    fillTypesOptions(data) {
      this.typesOptions = data.map((a) => {
        return {
          key: a.ActionType.key,
          text: a.ActionType.name,
          value: a.ActionType.id
        }
      })
    },
    fillCountryOptions(data) {
      this.countryOptions = data.map((a) => {
        return {
          key: a.Country.id,
          text: a.Country.name,
          value: a.Country.id
        }
      })
    },
    fillActionProvidersOptions(data) {
      this.actionProvidersOptions = data.map((a) => {
        return {
          key: a.ActionProvider.id,
          text: a.ActionProvider.name,
          value: a.ActionProvider.id
        }
      })
    },
    fillStatusOptions(data) {
      this.actionStatusOptions = data.map((a) => {
        return {
          key: a.ActionApt.action_status,
          text: a.ActionApt.action_status.toUpperCase(),
          value: a.ActionApt.action_status
        }
      })
    },
    fillStocksOptions(stocks) {
      stocks.sort((a, b) => a.name.localeCompare(b.name));

      stocks.forEach(({ id, name, stock_type }) => {
        const stock = { id, key: id, value: id, text: name }

        if (stock_type === 'R') {
          this.stocksOptions.push(stock)
        } else {
          this.columnsOptions.push(stock)
        }
      });
    },
    actionInfo(params) {
      let routeData = this.$router.resolve('/inventory/action/info/' + params.row.id);
      window.open(routeData.href, '_blank');
    },
    goTo(where) {
      this.$router.push(where)
    }
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Inventory/actionList.vue